if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      this.promotion = this.querySelector('.promotion');
    }
    connectedCallback() {
      if (FoxTheme.config.motionReduced) return;
      this.stopInView = FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }
    disconnectedCallback() {
      if (typeof this.stopInView === 'function') this.stopInView();
      this.stopInView = null;
      this.observer?.disconnect();
    }
    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          // Visual repeats must not repeat the original links in the tab order or accessibility tree.
          this.clone.setAttribute('aria-hidden', 'true');
          FoxTheme.a11y.getFocusableElements(this.clone).forEach((element) => {
            element.setAttribute('tabindex', '-1');
          });
          this.appendChild(this.clone);
        }

      }
      // Reconnect the visibility observer without generating additional visual repeats.
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

      this.observer.observe(this);
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
